import React from "react";

import Grid from "@material-ui/core/Grid";

import BaseDialog from "../../../../../components/BaseDialog/BaseDialog";
import PrimaryButton from "../../../../../components/Buttons/PrimaryButton";
import SelectAssetCard
  from "../../../List/components/SyncWithRiskProfilePopup/components/SyncPopup/components/SelectAssetCard";
import CategoryHeader from "../../../List/components/CategoryHeader";
import {ASSETS_LIABILITIES_CONFIG} from "../../../constants";

import useStyles from "./styles";

const CreateLinkPopup = ({objectType, handleClose, itemsForLinks, handleSaveClick}) => {
  const [localItemsForLinks, setLocalItemsForLinks] = React.useState(itemsForLinks);

  const classes = useStyles();

  const assetTypeConfig = ASSETS_LIABILITIES_CONFIG[objectType];

  const handleCheckboxChange = (assetCategoryId, assetId) => {
    setLocalItemsForLinks(localItemsForLinks.map(category => ({
      ...category,
      assets: category.assets.map(asset =>
        (assetCategoryId === asset.type_id && asset.id === assetId) ? {...asset, selected: !asset.selected} : asset
      )
    })))
  };

  const confirmSelected = () => {
    const selectedItems = [];
    localItemsForLinks.forEach(category => {
      category.assets.forEach((asset) => {
        if(asset.selected){
          selectedItems.push({...asset})
        }
      })
    });

    handleSaveClick(selectedItems);
  };

  return (
    <BaseDialog
      open
      maxWidth={'sm'}
      title={`${assetTypeConfig.linkItemLabel} hinzufügen`}
      handleClose={handleClose}
      actions={
        <Grid container spacing={1} justify={"flex-end"}>
          <Grid item>
            <PrimaryButton
              variant={'outlined'}
              color={'secondary'}
              text={'Abbrechen'}
              onButtonClick={handleClose}
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              text={'Verknüpfen'}
              onButtonClick={confirmSelected}
            />
          </Grid>
        </Grid>
      }
    >
      <Grid container spacing={1}>
        <Grid item xs={12} className={classes.subHeader}><b>{assetTypeConfig.addLinkSubHeader}</b></Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {localItemsForLinks.map(category => (
              <Grid key={category.id} item xs={12}>
                <Grid container spacing={1}>
                  <CategoryHeader category={category} objectType={objectType} withTotal={false} />
                  {category.assets.map((asset) => (
                    <Grid item xs={12} key={asset.id}>
                      <SelectAssetCard
                        item={asset}
                        categoryIcon={category.icon}
                        handleCheckboxChange={() => handleCheckboxChange(asset.type_id, asset.id)}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </BaseDialog>
  )
};

export default CreateLinkPopup;